const $ = jQuery;

module.exports = class {

    #cache = new Map();
    #searchTerm = '';

    config = {
        id: 'lumeris-combobox-' + Date.now(),
        ajax: {
            url: null,
            method: 'GET',
            params: {}
        },
        allowedCharacters: '01234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ -+&',
        filterCallback: null, 
        autocapitalization: 'off',
        autocomplete: 'off',
        autocorrect: 'off',
        delay: 500,
        inputName: 'term',
        minimumLength: 3,
        pattern: null,
        placeholder: '',
        selector: '.lumeris-combobox',
        spellcheck: 'false',
        optionsCallback: null,
        cache: true,
        cacheLimit: 20
    };

	constructor(config) {
		if (config === undefined) {
			return false;
		}

		this.$el = config.$el;

        if (this.$el.length === 0) {
            console.error('No element found.');
            return false;
        }
        
        this.config = {...this.config, ...config};
        this.config.id = this.config.id || this.$el.attr('id') || 'lumeris-combobox-' + Date.now();
        this.config.ajax.url = (this.config.ajax.url) ? this.resolveUrl(this.config.ajax.url) : null;

        if (this.$el.attr('data-name')) {
            this.config.inputName = this.$el.attr('data-name');
        }

        if (this.$el.attr('data-placeholder')) {
            this.config.placeholder = this.$el.attr('data-placeholder');
        }
        
        this.build();
		this.bind();

        this.$el.addClass('initialized');
	}

    bind() {
        this.$input.on('input', (event) => { this.onInput(event); });
        this.$input.on('focus', (event) => { this.onInputFocus(event); });
        this.$input.on('keypress', (event) => { this.onInputKeypress(event); });
        this.$searchButton.on('click', (event) => { this.onSearchButtonClick(event); });
        this.$clearButton.on('click', (event) => { this.onClearButtonClick(event); });
        $(window).on('resize', (event) => { this.onWindowResize(event); });
        $(window).on('click', (event) => { this.onWindowClick(event); });
    }

    build() {
        this.$inputContainer = $('<div class="search-field"></div>');
        this.$input = $('<input type="text">');
        this.$clearButton = $('<button class="clear" type="button"><span class="mdi mdi-close"></span></button>');
        this.$searchButton = $('<button class="search" type="button"><span class="mdi mdi-magnify"></span></button>');
        this.$dropdown = $('<div class="dropdown">');
        this.$searching = $('<div class="searching">Searching<span class="dots"></span></div>');
        this.$list = $('<ul role="listbox">');

        this.$el
            .attr('id', this.config.id)
            .attr('role', 'combobox')
            .attr('aria-haspopup', 'listbox')
            .attr('aria-expanded', 'false');

        this.$input
            .attr('name', this.config.inputName)
            .attr('placeholder', this.config.placeholder)
            .attr('autocomplete', this.config.autocomplete)
            .attr('autocapitalization', this.config.autocapitalization)
            .attr('autocorrect', this.config.autocorrect)
            .attr('spellcheck', this.config.spellcheck)
            .attr('aria-autocomplete', 'list')
            .attr('pattern', this.config.pattern);

        this.$list.prepend(this.getNoResultsOption());
        this.$inputContainer.prepend(this.$searchButton);
        this.$inputContainer.prepend(this.$clearButton);
        this.$inputContainer.prepend(this.$input);
        this.$dropdown.prepend(this.$list);
        this.$dropdown.prepend(this.$searching);
        this.$el.prepend(this.$dropdown).prepend(this.$inputContainer);
    }

    bindListOptions() {
        this.$list.find('a').on('click', (event) => { this.onListOptionClick(event); });
    }

    get searchTerm() {
        return this.#searchTerm;
    }

    get cache() {
        return this.#cache;
    }

    getCache(key) {
        return this.cache.get(key) || null;
    }

    getNoResultsOption() {
        return '<li role="option" aria-selected="false"><span>No results were found.</span></li>';
    }

    async getResults(term) {
        if (!term || !this.config.ajax || !this.config.ajax.url) {
            return false;
        }

        const cacheKey = term.toLowerCase();
        const cachedData = this.getCache(cacheKey);
        
        if (cachedData) {
            return cachedData;
        }

        const params = {...this.config.ajax.params};
        for (let p in params) {
            if (params[p] === '{{term}}') {
                params[p] = term;
            }
        }

        const url = new URL(this.config.ajax.url);
        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url, {
                method: this.config.ajax.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cache: 'no-cache'
            });
        
            const json = await response.json();

            if (!json.code || (json.data?.status !== undefined && json.data.status !== 400)) {
                this.setCache(cacheKey, json);
            }

            return json;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    set searchTerm(val) {
        this.#searchTerm = val;
        this.$el.trigger('lumeris-combobox:updated-search-term', {searchTerm: val});
        this.$el.trigger('lumeris-combobox:updated-search-term:' + this.config.id, {searchTerm: val});
    }

    setCache(key, value) {
        if (key && value !== undefined) {
            this.cache.set(key, value);

            if (this.cache.size > this.config.cacheLimit) {
                this.cache.delete(this.cache.keys()[0]);
            }
        }
    }

    updateResults(optionsData) {

        this.clearResults();

        if (!optionsData || optionsData.length == 0) {
            this.$list.append(this.getNoResultsOption());
        } else {
            const regexp = new RegExp('(' + this.searchTerm + ')', 'i');
            const options = optionsData.map(({ value, label }) => {
                const highlightedLabel = label.replace(regexp, '<strong class="term-match">$1</strong>');
                return `<li role="option" aria-selected="false"><a href="#" data-value="${value}">${highlightedLabel}</a></li>`;
            }).join('');
          
            this.$list.append(options);
            this.bindListOptions();
        }

        this.$el.trigger('lumeris-combobox:updated-results', {
            term: this.searchTerm, 
            data: optionsData
        });

        this.$el.trigger('lumeris-combobox:updated-results:' + this.config.id, {
            term: this.searchTerm, 
            data: optionsData
        });
    }

    resolveUrl(url) {
        const anchor = document.createElement('a');
        anchor.href = url;
      
        if (anchor.protocol === ':' || anchor.protocol === '') {
          anchor.href = `${window.location.origin}/${anchor.href}`;
        }

        return anchor.href;
    }

    selectOption(val='') {
        this.$el.trigger('lumeris-combobox:select', {option: val});
        this.$el.trigger('lumeris-combobox:select:' + this.config.id, {option: val});
    }

    showSearching() {
        this.$el.addClass('is-searching');
    }

    hideSearching() {
        this.$el.removeClass('is-searching');
    }

    showDropdown() {
        this.$el.attr('aria-expanded', 'true');
    }

    hideDropdown() {
        this.$el.attr('aria-expanded', 'false');
    }

    clearInput() {
        this.$input.val('');
        this.clearResults();
        this.hideDropdown();
    }

    clearResults() {
        this.$list.html('');
    }

    filterValue(val) {
        if (typeof this.config.filterCallback === 'function') {
            return this.config.filterCallback(val, this.config);
        }

        let filteredVal = val.replace(/[\/\\]/g, '').trim();

        if (this.config.allowedCharacters) {
            filteredVal = filteredVal.replace(new RegExp(`[^${this.config.allowedCharacters}]`), 'g');
        }

        return filteredVal;
    }

    search() {
        const term = this.filterValue(this.$input.val());
        this.$input.val(term);

        clearTimeout(this.timeout);
        this.searchTerm = term;

        if (term.length < this.config.minimumLength) {
            this.hideDropdown();
            this.clearResults();
            return false;
        }

        this.timeout = setTimeout(() => {
            requestAnimationFrame(() => {
                this.showSearching();
                return this.doSearch(term).then((optionsData) => {
                    if (this.searchTerm === term) {
                        this.updateResults(optionsData);
                    }
                    this.hideSearching();
                    this.showDropdown();
                }); 
            });
        }, this.config.delay);
    }

    async doSearch(term) {
        if (!term) {
            return null;
        }

        const data = await this.getResults(term);
        return (typeof this.config.optionsCallback === 'function') ? this.config.optionsCallback(data, this.config) : null;
    }

    on(event, callback) {
        return this.$el.on(event, callback);
    }

    onInput(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        this.search();
    }

    onInputKeypress(event) {
        if (!(event.originalEvent instanceof Event) || event.keyCode !== 13) {
            return false;
        }

        this.search();
    }

    onInputFocus(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'focus' }}));
        if (this.$list.find('li').length !== 0) {
            this.showDropdown();
        }
    }

    onSearchButtonClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'search' }}));
        this.search();
    }

    onClearButtonClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'clear' }}));
        this.clearInput();
    }

    onListOptionClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        event.preventDefault();

        let $target = $(event.target);
        let val = $target.attr('data-value');

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'select' }}));
        this.selectOption(val);
        this.clearInput();
    }

    onWindowResize(event) {
        if (!(event instanceof Event)) {
            return false;
        }

        this.$dropdown.width(this.$inputContainer.width());
    }

    onWindowClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        let $target = $(event.target);

        if ($target.is(this.config.selector) || $target.parents(this.config.selector).length !== 0) {
            return false;
        }

        this.hideDropdown();
    }
}